<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nmFb50/tc-custom/9781497674011.jpg?1734036360549" alt="This image is the cover for the book Trouble with Andrew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trouble with Andrew
      </h1>
      <p class="bookDescription body article font2">
        <b>For single mother Katie Wells, there are <i>two</i> Hurricane Andrews wreaking havoc on her heart</b><br/><br/> Hurricane Andrew rages through Southern Florida with the force of God’s wrath. In the blink of an eye, Katie Wells’s Miami home is destroyed, her former life gone. All she wants now is to make sure her young son stays safe. Rescue arrives in the form of Andrew Cunningham, the architect who built her house.<br/><br/> As neighbors work together to rebuild, Katie realizes she’s starting to fall for Drew. But something doesn’t add up. With devastation all around them, why did a few houses—including his—remain standing? Her quest for answers uncovers a twisting trail of sabotage and cover-up that conceals the shocking truth about Andrew.<br/><br/> Heather Graham uses her firsthand knowledge of one of the last century’s worst natural disasters to weave an unforgettable love story that’s a testament to the resilience of the human spirit.<br/><br/> This ebook features an illustrated biography of Heather Graham, including rare photos from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Graham
      </h2>
      
      <p class="authorDescription body article">Heather Graham (b. 1953) is a bestselling author of more than 150 romance, suspense, and historical novels that have sold seventy-five million copies worldwide. Raised in Florida, Graham went to college for theater arts, and spent several years acting, singing, and bartending before she devoted herself to writing. Her first novel, <i>When Next We Love</i>, was published in 1982. Although she became famous as an author of romance novels, Graham has since branched out into supernatural horror, historical fiction, and suspense, with titles such as <i>Tall, Dark, and Deadly </i>(1999), <i>Long, Lean, and Lethal </i>(2000), and<i> Dying to Have Her </i>(2001). In 2003 the Romance Writers of America, whose Florida chapter Graham founded, granted her a lifetime achievement award. She lives, writes, and scuba dives in Florida with her husband and five children. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65019e7b